import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const Head = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
    text-transform: uppercase;
`;

const QrImg = styled.img`
    background: var(--page-bg);
    display: block;
    margin: 0 auto 3rem;
    padding: 0.5rem;
`;

function ConfirmationCandybarHead({ data }) {
    if (!data) {
        return null;
    }

    return <div>
        <Head>
            <div>{data.cinema && data.cinema.name}</div>
            <div>{data.purchase_date && moment(data.purchase_date).format('DD/MM/YYYY')}</div>
        </Head>
        <QrImg src={data.qr} />
    </div>
}

export default ConfirmationCandybarHead;